import Vue from "vue";
import VueRouter from "vue-router";

import LoginPage from "@/pages/LoginPage";
import MainProps from "@/pages/MainProps";
import BusinessProcess from "@/pages/BusinessProcess";
// import WidgetsPage from "@/pages/WidgetsPage";

import TranshUx from "@/pages/TranshUx";
import HomeScreenUx from "@/pages/HomeScreenUx";
import HistoryUx from "@/pages/HistoryUx";

import AppTranslate from "@/pages/AppTranslate";
import ProfileUx from "@/pages/ProfileUx.vue";
import PaymentUx from "@/pages/PaymentUx.vue";

import NodeRedactorFrame from "@/pages/NodeRedactorFrame.vue";

import Variables from '@/pages/VariablesAndRules/VariablesPage.vue'
import Rules from '@/pages/VariablesAndRules/RulesPage.vue'

import ExternalSources from '@/pages/ExternalSources/ExternalSourcesPage.vue'
import Endpoints from '@/pages/ExternalSources/Endpoints.vue'

import ReferencesUniversal from '@/pages/References/ReferencesUniversal.vue'
import ProjectsList from '@/pages/ProjectsAndProcesses/ProjectsList.vue'

import Properties from '@/pages/Properties/Properties.vue'

import Actions from '@/pages/Actions/Actions.vue'

Vue.use(VueRouter);

const routes = [
  {
    name: "main-props",
    path: "/main-props",
    component: MainProps,
  },
  {
    name: "business-process",
    path: "/business-process",
    component: BusinessProcess,
  },
  {
    name: "app-translate",
    path: "/app-translate",
    component: AppTranslate,
  },
  {
    name: "login",
    path: "/login",
    component: LoginPage,
  },
  {
    name: "transhux",
    path: "/transhux",
    component: TranshUx
  },
  {
    name: "profileux",
    path: "/profileux",
    component: ProfileUx
  },
  {
    name: "homescreenux",
    path: "/homescreenux",
    component: HomeScreenUx
  },
  {
    name: "historyux",
    path: "/historyux",
    component: HistoryUx
  },
  {
    name: "paymentux",
    path: "/paymentux",
    component: PaymentUx
  },
  // {
  //   name: 'widgets',
  //   path: "/widgets",
  //   component: WidgetsPage
  // },
  {
    name: 'variables',
    path: "/variables",
    component: Variables
  },
  {
    name: 'rules',
    path: "/rules",
    component: Rules
  },
  {
    name: 'external-sources',
    path: "/external-sources",
    component: ExternalSources
  },
  {
    name: 'endpoints',
    path: "/endpoints",
    component: Endpoints
  },
  {
    name: 'references-universal',
    path: "/references-universal",
    component: ReferencesUniversal
  },
  {
    name: 'projects-list',
    path: "/projects-list",
    component: ProjectsList
  },
  {
    name: "nodeRedactorFrame",
    path: "/node-redactor-frame",
    component: NodeRedactorFrame,
  },
  {
    name: "properties",
    path: "/properties",
    component: Properties,
  },
  {
    name: "actions",
    path: "/actions",
    component: Actions,
  },
  {
    path: "*",
    redirect: "/business-process",
  },
];

export const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login", "/node-redactor-frame"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("accessToken");

  if (authRequired && !loggedIn) {
    return next("/login");
  } else if (loggedIn && publicPages.includes(to.path)) {
    return next("/");
  }

  next();
});

export default router;
